<template>
  <div class="messageModel clearfix">
    <!-- CartModel start modelmsg2 model  @mousedown="mousedown"-->
      <div class="modelbgcolor" v-show="flag">
      </div> 
   <div class="querenmodel  modelmsg2 clearfix" v-show="flag" :id="id">
        <div class="content clearfix" :class="{isquerencontent:msgShow}" @mousedown="mousedown" id="modelcontent">
          <div class="title">
            <span class="fl">{{types}}</span>
            <span class="fr" @click="returnMsg(false)"><i class="iconfont icon-guanbi"></i></span>
          </div> 
          <div class="numbox" v-if="!msgShow" style="text-align: left;margin: 10px 20px;">
               <span>
              {{msg}}
            </span>
          </div> 
          <div class="numbox" v-else style="text-align: left;margin: 10px 20px;overflow-y: auto;height:272px">
            <el-input type="textarea" autosize v-model="msg"></el-input>
          </div>
          <div class="clearfix">
            <el-button type="primary" v-if="butflag" class="fr tijiao" style="margin:20px 20px 0" size="small" @click="returnMsg(true)">{{butmsg}}</el-button>
            <el-button type="primary" v-else class="fr tijiao" style="margin:0px 20px 0" size="small" @click="returnMsg(true)">{{butmsg}}</el-button>
            <el-button v-show="butflag" type="warning" class="fl tijiao" style="margin:20px 0 0 20px;" size="small" @click="returnMsg(false)">取消</el-button>
          </div>
        </div>
   </div>
  <!-- CartModel end-->
  </div>
</template>

<script>
export default {
   name: 'MessageModel',
   props:{
    'types':String, 
    'butmsg':String, 
    'msg':String,
    'flag':Boolean,
    'butflag':Boolean, 
    'msgShow':Boolean, 
   },
   data() {
       return {
         id: 'modelmsg',
         selectElement: ''
       }
     },
    methods: { 
      returnMsg(flag){   
        this.$emit('modelmsg',flag);
        if(!flag){
          document.getElementById(this.id).style.top =0;
          document.getElementById(this.id).style.left =0;
        }
      },
       mousedown(event) {
         this.selectElement = document.getElementById(this.id)
         var div2 = document.getElementById("modelcontent")
         var div1 = this.selectElement
         this.selectElement.style.cursor = 'move'
         this.isDowm = true
         var distanceX = event.clientX - this.selectElement.offsetLeft
         var distanceY = event.clientY - this.selectElement.offsetTop 
         // console.log(distanceX)
         // console.log(distanceY)
         document.onmousemove = function (ev) {
           var oevent = ev || event
           div1.style.left = oevent.clientX - distanceX + 'px'
           div1.style.top = oevent.clientY - distanceY + 'px'
           div1.style.margin =0+'!important'; 
           
         }
         document.onmouseup = function () {
           document.onmousemove = null
           document.onmouseup = null
           div2.style.cursor = 'default'
         }
      }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MessageModel.vue